// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"0855ca37","62":"dab86e0c","227":"743a390f","275":"ef2c5da5","362":"c12b4692","386":"9d4c2dc3","615":"25e09829","742":"e28a9a0d","858":"3a0d6c3f","919":"0855ca37","932":"7e7da916"}[chunkId] + ".chunk.css";
};